import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Avatar,
  Box,
  Typography,
  IconButton
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { apiCall } from "../config/api";

const AddUserModal = ({ open, onClose, onUserAdded }) => {
  const [displayName, setDisplayName] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setError("Lütfen geçerli bir resim dosyası seçin");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setError("Resim dosyası 5MB'dan küçük olmalıdır");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      setPhotoURL(e.target.result);
      setError(null);
    };
    reader.onerror = () => {
      setError("Resim yüklenirken bir hata oluştu");
    };
    reader.readAsDataURL(file);
  };

  const handleAddUser = async () => {
    if (!displayName.trim() || !email.trim() || !password.trim()) {
      setError("İsim, e-posta ve şifre zorunludur.");
      return;
    }
    setSaving(true);
    setError(null);
    try {
      const response = await apiCall('/api/admin/users', {
        method: 'POST',
        body: JSON.stringify({
          displayName,
          email,
          password,
          photoURL,
        }),
      });

      if (!response.success) {
        throw new Error(response.error || 'Bilinmeyen bir hata oluştu.');
      }
      const newUser = response.data || response.user;
      onUserAdded && onUserAdded(newUser);
      setDisplayName("");
      setPhotoURL("");
      setEmail("");
      setPassword("");
      onClose();
    } catch (err) {
      setError("Kullanıcı eklenirken hata oluştu: " + err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Yeni Kullanıcı Ekle</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 2 }}>
          <Box sx={{ position: "relative", mb: 2 }}>
            <Avatar src={photoURL} sx={{ width: 80, height: 80 }} />
            <input
              accept="image/*"
              style={{ display: "none" }}
              id="raised-button-file"
              type="file"
              onChange={handleFileChange}
            />
            <label htmlFor="raised-button-file">
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="span"
                sx={{
                  position: "absolute",
                  bottom: -10,
                  right: -10,
                  backgroundColor: "white",
                  boxShadow: 1,
                  "&:hover": { backgroundColor: "#f5f5f5" },
                }}
              >
                <CloudUpload />
              </IconButton>
            </label>
          </Box>

          <TextField
            autoFocus
            margin="dense"
            label="Ad Soyad"
            type="text"
            fullWidth
            value={displayName}
            onChange={e => setDisplayName(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="E-posta"
            type="email"
            fullWidth
            value={email}
            onChange={e => setEmail(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Şifre"
            type="password"
            fullWidth
            value={password}
            onChange={e => setPassword(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Fotoğraf URL (veya yukarıdan yükleyin)"
            type="url"
            fullWidth
            value={photoURL}
            onChange={e => setPhotoURL(e.target.value)}
            sx={{ mb: 2 }}
            helperText="Dosya seçerseniz URL otomatik dolar"
          />
          {error && <Typography color="error" sx={{ mt: 1 }}>{error}</Typography>}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>İptal</Button>
        <Button onClick={handleAddUser} variant="contained" disabled={saving}>
          {saving ? "Kaydediliyor..." : "Ekle"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddUserModal;
